'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _desc, _value, _class2, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = require('react-router-dom');

var _withRouter = require('../../helpers/withRouter');

var _withRouter2 = _interopRequireDefault(_withRouter);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _sleep = require('../../helpers/sleep');

var _sleep2 = _interopRequireDefault(_sleep);

var _md = require('react-icons/md');

var _parseColor2 = require('../../helpers/parseColor');

var _parseColor3 = _interopRequireDefault(_parseColor2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var Navigator = (0, _withRouter2.default)(_class = (_class2 = (_temp2 = _class3 = function (_React$Component) {
  (0, _inherits3.default)(Navigator, _React$Component);

  function Navigator() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Navigator);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Navigator.__proto__ || Object.getPrototypeOf(Navigator)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Navigator, [{
    key: 'componentDidMount',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.inner.addEventListener('scroll', this.checkScroll);
                window.addEventListener('resize', this.checkScroll);
                this.checkScroll();
                _context.next = 5;
                return (0, _sleep2.default)(200);

              case 5:
                if (this.inner) {
                  this.checkScroll();
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _ref2.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.inner.removeEventListener('scroll', this.checkScroll);
      window.removeEventListener('resize', this.checkScroll);
    }
  }, {
    key: 'checkScroll',
    value: function checkScroll() {
      var element = this.inner;
      var width = element.offsetWidth;
      var innerWidth = element.scrollWidth;
      var scrollLeft = element.scrollLeft;
      var offsetRight = innerWidth - scrollLeft - width;

      if (width >= innerWidth) {
        this.setState({
          isSmall: window.innerWidth <= 1220,
          showShadows: false,
          showArrowLeft: false,
          showArrowRight: false
        });
      } else {
        this.setState({
          isSmall: window.innerWidth <= 1220,
          showShadows: true,
          showArrowLeft: scrollLeft > 10,
          showArrowRight: offsetRight > 10
        });
      }
    }
  }, {
    key: 'renderItems',
    value: function renderItems() {
      var _this2 = this;

      var items = this.props.items.map(function (item, index) {
        var pathname = _this2.props.router.location.pathname;
        var active = item.path === '/' ? pathname === item.path : pathname.startsWith(item.path);
        var classNames = ['os-navigator-item'];
        if (active) classNames.push('os-navigator-itemActive');
        return _react2.default.createElement(
          'div',
          { key: index, className: classNames.join(' ') },
          _react2.default.createElement(
            _reactRouterDom.Link,
            { to: item.path },
            item.title
          )
        );
      });

      var classNames = ['os-navigator-inner'];
      if (this.state.isSmall) {
        classNames.push('os-navigator-inner-small');
      }
      return _react2.default.createElement(
        'div',
        { className: classNames.join(' '), ref: function ref(_ref3) {
            _this2.inner = _ref3;
          } },
        items
      );
    }
  }, {
    key: 'renderShadow',
    value: function renderShadow() {
      if (!this.state.showShadows) return;

      var _parseColor = (0, _parseColor3.default)(this.props.color),
          red = _parseColor.red,
          green = _parseColor.green,
          blue = _parseColor.blue;

      var color = [red, green, blue].join(', ');
      var element = this.inner;
      var top = element.getBoundingClientRect().top + window.scrollY;
      var left = element.getBoundingClientRect().left + window.scrollX;
      var right = element.getBoundingClientRect().right - window.scrollX;
      var getStyle = function getStyle(isLeft) {
        return {
          top: top,
          left: isLeft ? left : right - 30,
          background: '-webkit-gradient(linear,' + (isLeft ? '100' : '0') + '% 50%,' + (isLeft ? '0' : '100') + '% 50%,color-stop(0%, rgba(' + color + ', 0)),color-stop(100%, rgba(' + color + ', 1)))'
        };
      };
      return [_react2.default.createElement('div', { key: 'left', className: 'os-navigator-shadow', style: getStyle(true) }), _react2.default.createElement('div', { key: 'right', className: 'os-navigator-shadow', style: getStyle(false) })];
    }
  }, {
    key: 'renderMdChevronRight',
    value: function renderMdChevronRight() {
      var element = this.inner;
      if (!element) return;
      var top = element.getBoundingClientRect().top + window.scrollY;
      var right = element.getBoundingClientRect().right - window.scrollX;
      return _react2.default.createElement(
        'div',
        {
          className: 'os-navigator-icon',
          style: { opacity: this.state.showArrowRight ? 1 : 0, top: top, left: right - 30 } },
        _react2.default.createElement(_md.MdChevronRight, { size: 30 })
      );
    }
  }, {
    key: 'renderMdChevronLeft',
    value: function renderMdChevronLeft() {
      var element = this.inner;
      if (!element) return;
      var top = element.getBoundingClientRect().top + window.scrollY;
      var left = element.getBoundingClientRect().left + window.scrollX;
      return _react2.default.createElement(
        'div',
        {
          className: 'os-navigator-icon',
          style: { opacity: this.state.showArrowLeft ? 1 : 0, top: top, left: left } },
        _react2.default.createElement(_md.MdChevronLeft, { size: 30 })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'os-navigator-container', style: { background: this.props.color } },
        this.renderItems(),
        this.renderShadow(),
        this.renderMdChevronLeft(),
        this.renderMdChevronRight()
      );
    }
  }]);
  return Navigator;
}(_react2.default.Component), _class3.propTypes = {
  router: _propTypes2.default.object,
  items: _propTypes2.default.array,
  color: _propTypes2.default.string
}, _class3.defaultProps = {
  color: '#0069ff'
}, _temp2), (_applyDecoratedDescriptor(_class2.prototype, 'checkScroll', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class2.prototype, 'checkScroll'), _class2.prototype)), _class2)) || _class;

exports.default = Navigator;